import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=cff8e8ac&scoped=true&"
import script from "./UserSidebar.vue?vue&type=script&lang=js&"
export * from "./UserSidebar.vue?vue&type=script&lang=js&"
import style0 from "./UserSidebar.vue?vue&type=style&index=0&id=cff8e8ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff8e8ac",
  null
  
)

export default component.exports